import styled from "styled-components";

const TableHead = styled.thead`
  background: ${({ theme }) => theme.lightPrimaryColor};
  border-top: 1px solid ${({ theme }) => theme.dividerColor};
  border-bottom: 2px solid ${({ theme }) => theme.dividerColor};
`;

export default TableHead;
